import { createWebHistory, createRouter} from "vue-router";

import paHome from "./components/Company"


const routes = [
    {
        path: "/",
        name: "paHome",
        component: paHome,
    }

]


const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;